// Giorni ('YYYY/MM/DD') o orari ('HH:mm') liberi solo negli altri centri inclusi e non in
// quello corrente: nel calendario unificato hanno il puntino. Nessun puntino finché i dati
// del centro corrente non sono caricati, altrimenti tutto sembrerebbe libero solo altrove.
// Con le ore a due cifre l'ordine alfabetico è quello cronologico, come per le date.
export const getElsewhereOnly = (
  current: string[],
  others: string[][],
  isCurrentLoaded: boolean
): string[] => {
  if (!isCurrentLoaded) return [];
  const currentValues = new Set(current);
  return Array.from(new Set(others.flat()))
    .filter((value) => !currentValues.has(value))
    .sort();
};
